import linker from './entityName.linker'

export default ['$state', '$timeout', function($state) {
  return {
    restrict: 'E',
    link: linker($state),
  }
}]

